import raterJs from "rater-js";
import { loadScript, yieldToMainBackground } from "./utils";

export const initRating = (container) => {
	const star = container.querySelector("._star_widget");
	const label = container.querySelector("._rating-label");
	const error = container.querySelector("._rating-error");
	const user_vote = container.querySelector("._rating-vote");
	const initial_vote = Number.parseFloat(star.dataset.rating);
	const rater_options = {
		starSize: star.dataset.starWidth,
		step: star.dataset.halfStar ? 0.5 : 1,
		readOnly: !!star.dataset.readOnly,
		element: star,
		showToolTip: false,
		rating: initial_vote,
	};

	if (initial_vote) {
		rater_options.readOnly = true;
		raterJs(rater_options);
	} else {
		rater_options.onHover = (currentIndex, currentRating) => {
			user_vote.textContent = `${currentIndex}/5`;
		};
		rater_options.onLeave = (currentIndex, currentRating) => {
			if (currentRating) {
				label.textContent = "Il tuo voto";
				user_vote.textContent = `${currentRating}/5`;
			} else {
				user_vote.textContent = "N/D";
			}
		};
		rater_options.rateCallback = function rateCallback(rating, done) {
			const vote_form = star.closest("form");

			fetch("/csrf/", {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			})
				.then((response) => {
					return response.text();
				})
				.then((data) => {
					if (
						!!vote_form.querySelector("input[name='csrfmiddlewaretoken']") ===
						false
					) {
						const input = document.createElement("input");
						input.setAttribute("name", "csrfmiddlewaretoken");
						input.setAttribute("type", "hidden");
						input.value = data;
						vote_form.appendChild(input);
					}
					const formData = new FormData();
					for (const el of vote_form.querySelectorAll("input")) {
						formData.append(el.getAttribute("name"), el.value);
					}
					formData.append("score", rating);
					fetch("/ratings/vote/", {
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						method: "POST",
						cache: "no-cache",
						body: formData,
					})
						.then((response) => {
							if (response.ok) {
								return response.json();
							}
							if (response.status === 400) {
								error.textContent = "Hai già votato";
								starRating.disable();
								throw new Error(response.statusText);
							}
						})
						.then((result) => {
							if (result.vote_score) {
								label.textContent = "Il tuo voto";
								user_vote.textContent = `${result.vote_score}/5`;
								starRating.setRating(result.vote_score);
								starRating.disable();
							} else {
								starRating.setRating(0);
								user_vote.textContent = "N/D";
								label.textContent = "Vota";
							}
							done();
						})
						.catch((error) => {
							console.warn(" --- Error: ", error);
							done();
						});
				})
				.catch((error) => {
					console.warn(" --- Error: ", error);
				});
		};
		const starRating = raterJs(rater_options);
	}
};

export const loadRating = async (element, mark_opened = null) => {
	await fetch(
		`/misc/rating_form/${element.dataset.ct}/${element.dataset.id}/`,
		{
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		},
	)
		.then((response) => response.json())
		.then((data) => {
			if (data.captcha) {
				loadScript(
					"jquery_script-js",
					"/static/js/libraries/jquery-3.5.1.min.js",
				).then(() => {
					$(element).html(data.template);
				});
			} else {
				element.innerHTML = data.template;
				initRating(element);
			}
			if (mark_opened) {
				mark_opened.dataset.opened = true;
			}
		})
		.catch((error) => {
			console.warn(error);
		});
};

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	if (document.querySelector("#_form_rating")) {
		loadRating(document.querySelector("#_form_rating"));
	}

	document.addEventListener("click", (event) => {
		if (event.target?.classList.contains("_load-rating")) {
			event.preventDefault();
			const parent = event.target.parentNode;
			const opened = parent.dataset.opened;
			const rating_container = parent.parentNode.querySelector("._form_rating");
			if (opened === "true") {
				rating_container.classList.toggle("d-none");
			} else {
				yieldToMainBackground().then(() => {
					loadRating(rating_container, parent);
				});
			}
		}
	});
});
